<template>
  <div class="my-upload">
    <div
      class="my-upload-list"
      style="ling-height:100px;"
      v-for="(item, index) in uploadList"
      :key="'upload' + index"
    >
      <template v-if="item.status === 'finished' && index <= config.limitNum">
        <video
          :src="item.url"
          :poster="item.src"
          v-if="config.fileType=='video'"
          style="width:100%;height:100%;object-fit:fill;"
        >您的浏览器不支持 video 标签。</video>
        <img
          :src="item.url"
          v-if="config.fileType=='img'"
          style="
            width: 100px;
            height: 100px;"
        />
        <div class="my-upload-list-cover" style="line-height:100px;">
          <Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
          <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
        </div>
      </template>
      <template v-else>
        <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
          <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
        </Spin>
      </template>
    </div>
    <Upload
      :ref="config.id"
      :show-upload-list="false"
      :on-success="handleSuccess"
      :format="config.format"
      :max-size="config['max-size']"
      :headers="config.headers"
      :on-format-error="handleFormatError"
      :on-error="handleUploadError"
      :on-exceeded-size="handleMaxSize"
      :before-upload="handleBeforeUpload"
      multiple
      type="drag"
      :action="config.action"
      v-show="uploadList && uploadList.length <  config.limitNum"
      style="display: inline-block;"
    >
      <div style="width:100px;height:100px;padding-top: 15px;color:rgb(133, 133, 133);">
        <div style="font-size:25px;">
          +
          <p style="font-size:14px;text-align:center;">上传{{typeText}}</p>
        </div>
      </div>
      <div
        v-if="showHome"
        style="position:absolute;opacity:0;width:100px;height:100px;left:0;top:0;"
        @click.stop="selectType"
      ></div>
    </Upload>
    <p class="upload-p" style="width: 100%;font-size: 12px;color: #4d4d4d;">{{config.remind}}</p>
    <iModal title="预览" cancel-text v-model="visible">
      <div style="text-align: center;">
        <img :src="imgName.url" v-if="config.fileType=='img'" style="max-width: 100%" />
        <video
          :src="imgName.url"
          :poster="imgName.src"
          controls="controls"
          v-if="config.fileType=='video'"
          style="max-width: 100%"
        >您的浏览器不支持 video 标签。</video>
      </div>
    </iModal>
    <imgUpload
      v-if="config.fileType === 'img'"
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      :maxCount="usableNum"
      v-model="uploadChooseShowed"
    />
    <uploadVideoChoose
      v-if="config.fileType === 'video'"
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      :maxCount="usableNum"
      v-model="uploadChooseShowed"
    />
  </div>
</template>

<script>
import uploadVideoChoose from "@components/uploadVideoChoose/uploadVideoChoose";
import imgUpload from "@components/imgUpload/imgUpload.vue";
import { mapActions } from "vuex";
export default {
  props: {
    config: {
      default() {
        return {
          id: "upload",
          fileType: "img",
          headers: {},
          action: "",
          format: ["jpg", "jpeg", "png"],
          "max-size": 2048,
          remind: "(图片要求：2M以下jpg或png的图片，大小为：750*500px)",
          limitNum: 4,
          uploadList: [],
          albumOption: null // 上传到素材库的信息
        };
      }
    },
    fileList: {
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      defaultList: [],
      imgName: "",
      visible: false,
      uploadList: [],
      buttonShowed: true,
      uploadChooseShowed: false
    };
  },
  computed: {
    usableNum() {
      return this.config.limitNum - this.uploadList.length;
    },
    maxSize() {
      return this.config["max-size"] / 1024;
    },
    formatText() {
      return this.config.format.join(",");
    },
    uploadC() {
      return this.$refs[this.config.id];
    },
    typeText() {
      let text = "文件";
      if (this.config.fileType == "img") {
        text = "图片";
      } else if (this.config.fileType == "video") {
        text = "视频";
      }
      if (this.config.uploadTxt === "证书") {
        text = "证书";
      }
      return text;
    },
    showHome() {
      let bool = true;
      if (this.$route.path.indexOf("/host/index") !== -1) {
        bool = false;
      }
      if (this.$route.path.indexOf("/host/project") !== -1) {
        bool = false;
      }
      return bool;
    },
  },
  methods: {
    ...mapActions({
      addMaterial: "materialModule/addMaterial"
    }),
    uploadMaterial(e) {
      if (this.config.fileType === "img") {
        let num = this.config.limitNum - this.uploadList.length;
        e.map((val, index) => {
          if (index < num) {
            this.uploadList.push({
              status: "finished",
              url: val
            });
          }
        });
        this.$emit("upload-ok", this.outList());
        this.uploadChooseShowed = false;
        return;
      }
      for (let item of e) {
        if (item.Link) {
          this.uploadList.push({
            status: "finished",
            url: item.Link,
            src: item.Img
          });
        } else {
          this.uploadList.push({
            status: "finished",
            url: item.path,
            src: item.src,
            name: item.name
          });
        }
        this.$emit("upload-ok", this.outList());
      }
    },
    uploadLocal(album) {
      this.albumOption = album;
      this.uploadC.handleClick();
    },
    selectType(e) {
      this.uploadChooseShowed = true;
    },
    // 查看上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    // 移除上传图片
    handleRemove(file) {
      const fileList = this.uploadC.fileList;
      this.uploadC.fileList.splice(fileList.indexOf(file), 1);
      if (this.uploadList.length == this.config.limitNum - 1) {
        this.buttonShowed = true;
      }
      this.$emit("upload-ok", this.outList());
    },
    // 上传成功
    handleSuccess(res, file) {
      if (this.showHome) {
        if (res && res.list.length) {
          file.url = res.list[0];
          this.albumOption.Path = res.list[0];
          this.$emit("upload-ok", this.outList());
          this.sendImg();
        }
        let limitNum = this.config.limitNum;
        if (this.uploadList.length >= limitNum) {
          this.buttonShowed = false;
        }
      } else {
        if (res && res.list.length) {
          file.url = res.list[0];
          this.$emit("upload-ok", this.outList());
        }
        let limitNum = this.config.limitNum;
        if (this.uploadList.length >= limitNum) {
          this.buttonShowed = false;
        }
      }
    },
    outList() {
      //传出数据
      let list = [];
      for (const item of this.uploadList) {
        if (item.src) {
          list.push({
            url: item.url,
            src: item.src
          });
        } else {
          list.push(item.url);
        }
      }
      return list;
    },
    // 文件格式错误
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: `请上传${this.formatText}的文件`
      });
    },
    // 上传失败
    handleUploadError(file) {
      this.$Message.warning({
        content: "您的网络请求已超时,请重新上传",
        duration: 3,
        closable: true
      });
    },
    // 文件过大
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: `请上传小于${this.maxSize}M的文件`
      });
    },
    // 上传数量
    handleBeforeUpload(e) {
      let limitNum = this.config.limitNum;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}张图片`
        });
      }
      if (this.albumOption && e && e.name) {
        this.albumOption.Name = e.name;
      }
      return check;
    },
    initUploadList() {
      this.uploadList.splice(0, this.uploadList.length);
      for (let item of this.fileList) {
        if (item.src) {
          this.uploadList.push({
            status: "finished",
            url: item.url,
            src: item.src
          });
        } else {
          this.uploadList.push({
            status: "finished",
            url: item
          });
        }
      }
      if (this.uploadList.length >= this.config.limitNum) {
        this.buttonShowed = false;
      } else {
        this.buttonShowed = true;
      }
    },
    clearFiles() {
      this.uploadList = this.uploadC.fileList = [];
    },
    choose() {},
    sendImg() { 
      this.addMaterial(this.albumOption)
        .then(c => {
          
        })
        .catch(e => {
          this.$Message.error("添加图片到分组失败，请重新尝试");
        });
    }
  },
  watch: {
    fileList() {
      if (typeof this.fileList == "object") this.initUploadList();
    }
  },
  mounted() {
    this.uploadList = this.uploadC.fileList;
    this.initUploadList();
  },
  components: {
    uploadVideoChoose,
    imgUpload
  }
};
</script>

<style lang="scss" scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
.my-upload-list {
  margin-right: 0;
}
</style>